import { PortfolioIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

import PortfolioProductImage from '../../assets/product-images/portfolio-monitor-image.png';

export const APP_CONFIG_PORTFOLIO: AppConfig = {
  name: 'Portfolio Monitor',
  applicationKey: 'portfolio',
  type: 'product',
  appSlugForEngagement: AppSlugs.PortfolioMonitor,
  rootPath: `/monitor`,
  Icon: PortfolioIcon,
  descriptionLong:
    'Actively manage your portfolios by configuring notifications and analyzing data.',
  descriptionShort:
    'Get proactively notified about properties based on intelligent triggers.',
  marketingUrl: 'https://www.housecanary.com/products/portfolio-monitoring',
  marketingImage: PortfolioProductImage,
};

export const VIEW_PATHS_PORTFOLIO = {
  NEW_PORTFOLIO: 'new-portfolio',
  UPLOAD: 'upload',
  PORTFOLIO_SETUP: 'portfolio-setup',
  ALL_PORTFOLIOS: 'all-portfolios',
  PORTFOLIO: 'portfolio/:portfolioId',
  PORTFOLIO_DOWNLOAD_UPDATED_ASSETS:
    'portfolio/:portfolioId/download/:s3Identifier',
} as const;
